import { apiGateway } from "@contexts";
import { GetBankTransactionChallengeResponse } from "@interfaces";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { AxiosError } from "axios";
import { ErrorType } from "@screens/FeaAuth/hooks/onQuestionChallengeError";
import { useBankTransferAttempts } from "./useBankTransferAttempts";

interface Props {
  onError: (error: AxiosError<ErrorType>) => void;
}

export const useCreateBankTransferChallenge = ({ onError }: Props) => {
  const { registerAttempt } = useBankTransferAttempts();

  const onSuccess = useCallback(
    ({
      simplifiedPaymentUrl,
      paymentUrl,
    }: GetBankTransactionChallengeResponse) => {
      registerAttempt();
      window.location.href = simplifiedPaymentUrl || paymentUrl;
    },
    [registerAttempt],
  );

  return useMutation({
    mutationFn: () =>
      apiGateway<GetBankTransactionChallengeResponse>({
        url: "/enrolment/bank-transfer-challenge",
        method: "POST",
      }),
    onSuccess,
    onError,
  });
};
